import { EmailFilterStatus } from '@webapp/account/src/resources/mailing/email-detail';

export interface SmsFilters {
    status: EmailFilterStatus;
    startDatetime: string;
}

export const initialFilters: Readonly<SmsFilters> = {
    status: EmailFilterStatus.ALL,
    startDatetime: '',
};
